import { LOAD } from '@/config/app'

let manifest = [
  {
    id: LOAD.GROUPS.MAIN,
    urls: [ 
      require('@/assets/imgs/blue_matcap.jpg'), 
      require('@/assets/imgs/spritesheets/face.png'),
      require('@/assets/imgs/inside.jpg'),
      // require('@/assets/imgs/inside.jpg'),
      require('@/assets/imgs/home-tint-light.png'),
      require('@/assets/imgs/home-tint-dark.png')
    ]
  },
  {
    id: LOAD.GROUPS.BUBBLE,
    urls: [
      require('@/assets/models/bubble.glb') 
    ]
  } ,
  {
    id: LOAD.GROUPS.CHARACTER,
    urls: [ 
      require('@/assets/models/boy4.glb') 
    ]
  } 
] 


export default manifest